import React, { useEffect } from 'react';

import { useCurrentProject } from '@adsk/alloy-provider';
import { Box, Flex } from '@adsk/alloy-react-box';
import HighlightText from '@adsk/alloy-react-highlight-text';
import theme from '@adsk/alloy-react-theme';

import { THUMBNAIL_PLACEHOLDER } from '../helpers/consts';
import { getThumbnail } from '../helpers/utils';

const SheetInfoCell = ({
  entity,
  thumbnail,
  searchText,
  isDisabled,
  onThumbnailLoad,
}) => {
  const { sheetId, name, title, bubbleUrn, bubbleViewableGuid } = entity;
  const currentProject = useCurrentProject();
  const scopes = currentProject?.scopes?.project;
  useEffect(() => {
    const fetchThumbnail = async () => {
      const blob = await getThumbnail(bubbleUrn, bubbleViewableGuid, scopes);
      onThumbnailLoad({ sheetId, thumbnail: blob });
    };
    if (bubbleUrn && bubbleViewableGuid && thumbnail === undefined) {
      onThumbnailLoad({ sheetId, thumbnail: THUMBNAIL_PLACEHOLDER });
      fetchThumbnail();
    }
  }, [
    thumbnail,
    bubbleViewableGuid,
    bubbleUrn,
    sheetId,
    onThumbnailLoad,
    scopes,
  ]);

  return (
    <>
      <Flex
        minWidth="40px"
        height="40px"
        justifyContent="center"
        alignItems="center"
        marginRight="10px"
        flex="none"
      >
        {thumbnail && thumbnail !== THUMBNAIL_PLACEHOLDER ? (
          <img width={40} height={40} src={thumbnail} />
        ) : (
          <Box
            width="100%"
            height="100%"
            backgroundColor="charcoal050"
            border={`1px solid ${theme.colors.charcoal100}`}
          />
        )}
      </Flex>
      <Flex flexDirection="column" flex="1" overflow="hidden">
        <HighlightText
          matched={searchText}
          text={name}
          style={{
            color: isDisabled && theme.colors.charcoal500,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        />
        <HighlightText
          style={{
            minHeight: '20px',
            color: theme.colors[isDisabled ? 'charcoal500' : 'charcoal700'],
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
          matched={searchText}
          text={title}
        />
      </Flex>
    </>
  );
};

export default SheetInfoCell;
